import { HareketdetayPage } from './../../CariIslemleri/hareketdetay/hareketdetay';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { PerakendeFaturaDetayPage } from '../../faturaislemleri/perakende-fatura-detay/perakende-fatura-detay';



@Component({
  selector: 'page-cari-hareketleri',
  templateUrl: 'cari-hareketleri.html',
})
export class CariHareketleriPage {
  aranan = "";
  skip: number = 0;
  take: number = 50;
  HareketListesi = [];
  vwCari: any = {};
  aktifKullanici: any;
  Cari: any = { ID: "" };
  giden: any = {};
  Tahsilat: any;
  kullaniciyetkiseviyesi: any;
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public modalCtrl: ModalController,
    public viewCtrl: ViewController,
    public actionSheetCtrl: ActionSheetController,
    public navParams: NavParams) {

    if (navParams.get("vwCari") != null) {
      this.vwCari = navParams.get("vwCari");
      var data = new FormData();
      data.append("cari_id", this.vwCari.ID);
      this.bllOrtak.islem(data, "CariGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.Cari = Sonuc.SonucObject;

      }
      )
    }
    this.aktifKullanici = this.ortak.storagePersonelGetir.Name;
    this.kullaniciyetkiseviyesi = this.ortak.storagePersonelGetir.Type;
  }


  ionViewDidLoad() {

    this.KayitAra(this.aranan);
  }
  ionViewDidEnter() {
    this.KayitAra(this.aranan);
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  KayitAra(e) {
    this.aranan = this.vwCari.ID;
    var formData = new FormData();
    formData.append("aranan", JSON.stringify(this.aranan));
    this.bllOrtak.islem(formData, "CariHareketleri", "", false).then(a => {
      var sonuc = <any>a;
      this.HareketListesi = sonuc.SonucObject;
    })
  }
  urunler(e) {

    if (e.keyCode == 13) {
      this.KayitAra(e);
    }
  }
  carihareketleri(hareket) {
    if (hareket.IslemTuru == 12) {
      let modal = this.modalCtrl.create(PerakendeFaturaDetayPage, { vwFatura2: hareket });
      modal.onDidDismiss(data => {
        this.ionViewDidLoad();
      })
      modal.present();
    }
    else {
      let modal = this.modalCtrl.create(HareketdetayPage, { vwHareket: hareket });
      modal.onDidDismiss(data => {
        this.ionViewDidLoad();
      })
      modal.present();
    }
  }
  hareketsil(hareket) {
    if (this.kullaniciyetkiseviyesi == 1) {
      this.ortak.showBasicAlert("Uyarı", "Bu İşlemi Yapmaya Yetkiniz Yoktur!!!, Lütfen Yöneticiye Başvurunuz!!");
    }
    else if (this.kullaniciyetkiseviyesi == 2)
      this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz? Dikkatli Olun!!!").then(k => {
        var formData = new FormData();
        formData.append("ID", hareket.ID);
        this.bllOrtak.islem(formData, "HareketSil", "", false).then(a => {
          var sonuc = <any>a;
          if (sonuc.Sonuc == 1) {
            this.ortak.showBasicAlert("Başarılı", "Kayıt Başarılı Bir Şekilde Silindi");
            this.KayitAra(this.aranan);
          }
          if (sonuc.Sonuc != 1) {
            this.ortak.showBasicAlert("Hata", "Beklenmedik bir hata oluştu");

          }

        }).catch(x => {
         
        })

      })

  }

  Islemler(hareket) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Cari  İşlemleri',
      buttons: [
        {
          text: 'Detaylar',

          handler: () => {
            this.carihareketleri(hareket);
          }

        },
        {
          text: 'Kaydı Sil',
          handler: () => {
            this.hareketsil(hareket);
            this.KayitAra(this.aranan);
          }
        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/cari-hareketleri/cari-hareketleri.ts